// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\FeatureAnalyticClickResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type FeatureAnalyticClickApiResponse = {
	feature: string;
	count: number;
	updatedAt: string;
};

export type FeatureAnalyticClick = {
	feature: string;
	count: number;
	updatedAt: DateTime;
};

export function hydrateFeatureAnalyticClick(data: FeatureAnalyticClickApiResponse): FeatureAnalyticClick {
	return {
		...data,
		updatedAt: DateTimefromISO(data.updatedAt)!,
	};
}